export default "__VITE_PUBLIC_ASSET__b5f3f49c__"